












import { SdsIllustration } from '@superbet-group/web.lib.ui-components';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'CompetitionsEmptyStateBase',
    props: {
        illustrationName: {
            type: String,
            required: true,
        },
    },
    components: {
        SdsIllustration,
    },
});
